/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Pressable, Image } from '@components/atoms'
import { grey } from '@mui/material/colors'
import logoPng from '@public/images/logo/logo_white.png'

import { useNavigate, redirect } from 'react-router-dom'

export const Footer = () => {
	// hook
	const navigate = useNavigate()

	return (
		<View css={style}>
			<View className="footerLogoOuterView">
				<View className="footerLogoView">
					<Image
						src={logoPng}
						className="logoTitleWhite"
						style={{
							width: '5rem',
							height: '5rem',
							fontSize: 40,
							marginRight: 0,
							opacity: 0.8,
						}}
					/>
				</View>
				<Text className="rightText">© 2026 Judahs io</Text>
			</View>

			<View className="buisniessInfoView">
				<Text category="p2">대표이사: 김보람</Text>
				<Text category="p2">사업자번호: 469-06-02816</Text>
				<Text category="p2">Tel: 051) 791-1206</Text>
				<Text category="p2">주소: 부산 강서구 공항로 1225, 304호</Text>
				<Text category="p2">이메일: boram@judahs.io</Text>
			</View>
		</View>
	)
}

const style = css({
	position: 'relative',
	display: 'flex',
	justifyContent: 'left',
	width: '100%',
	padding: '1rem 2rem',
	background: grey[900],

	'.footerLogoOuterView': {
		position: 'relative',
		width: '10rem',
		height: '10rem',
		marginRight: '2rem',

		'.footerLogoView': {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			width: '10rem',
			height: '10rem',
			marginTop: '-1rem',
		},
		'.rightText': {
			position: 'absolute',
			bottom: '1rem',
			color: grey[300],
		},
	},

	'.buisniessInfoView': {
		textAlign: 'left',
		color: 'white',
	},

	'@media (max-width: 900px)': {
		'.footerView': {
			display: 'block',
			height: 'fit-content',

			'.categGroupView': {
				padding: '1rem 2rem',
			},

			'.footerLogoOuterView': {
				// width: '100%',
				height: '12rem',
				paddingBottom: '2rem',

				'.footerLogoView': {
					// width: '100%',
				},
				'.rightText': {
					width: '100%',
					textAlign: 'center',
				},
			},
		},
	},

	'@media (max-width: 550px)': {
		display: 'block',
		width: '100%',
		padding: '2rem',
	},
})
